<template>
  <div class="w-full  max-w-[1113px] min-w-[328px]">
    <section class="flex flex-col items-center w-full">
      <h4 class="self-start pt-12 pb-8 text-2xl font-medium">
        {{ $t("forum.topic.details.listComments.title") }}
      </h4>
    </section>
    <section 
      v-if="totalComments > 0" 
      class="flex flex-col items-center w-full md:px-0"
    >
      <CommentCard 
        v-for="comment in comments" 
        :comment="comment" 
        :topic="topic" 
        :key="comment.id"
        @deleteComment="deleteComment"
        @replyComment="replyComment" 
        @commentId="commentSelectedId"
        @isDenounceDialogVisible="isDenounceDialogVisible(true)" 
        class="mb-6" />
      <Paginator 
        :totalRecords="totalComments" 
        :rows="numberOfCommentsPerPage" 
        :value="comments"
        :first="getFirstItemIndexActualPage()" 
        @page="onPaginate" 
        :pageLinkSize="3"
        class="justify-center mb-16 md:flex md:w-full w-fit md:justify-end custom-paginator-forum"
      ></Paginator>
      <Dialog group="denouncingComment" v-model:visible="denounceDialogVisible" :style="{ maxWidth: '540px' }"
        class="w-11/12 custom-dialogForum" :modal="true">
        <template #header>
          <div class="flex justify-center w-full">
            <h2 class=" text-xl !font-medium text-black">
              {{
                $t("labels.generic", {
                  pt: "Denunciar comentário",
                  en: "Report comment",
                })
              }}
            </h2>

          </div>
        </template>
        <div>
          <div class="p-4 ">
            <p class="mb-6 text-base font-semibold text-neutral-900">
              {{
                $t("labels.generic",{
                  pt: "Agradecemos por ajudar a manter nossa comunidade segura e acolhedora. Por favor, selecione o motivo da sua denúncia: ",
                  en: "Thank you for helping to keep our community safe and welcoming. Please select the reason for your denounce: ",
                })
              }}</p>
              <div class="flex flex-col content-center gap-[14px]">
            <div v-for="denounce in denounceComment" :key="denounce.key" class="flex items-baseline align-items-center text-neutral-900">
              <RadioButton v-model="descriptionDenounce" :inputId="denounce.key" name="dynamic"
                :value="$t('labels.generic', {pt: denounce.labelPT, en: denounce.labelEN})"/>
              <label :for="denounce.key" class="ml-2 text-base font-medium font-mulish">
                {{ $t("labels.generic", { pt: denounce.labelPT, en: denounce.labelEN }) }}
              </label>
              </div>
            </div>
          </div>
        </div>
        <template #footer>
          <Button label="Cancelar" text severity="secondary" autofocus @click="isDenounceDialogVisible(false)" class="h-8 btn-outline"/>
          <Button label="Enviar denúncia" outlined severity="secondary" autofocus @click="reportComment" class="h-8 py-4 btn-primary"
            :disabled="isDenounceButtonDisabled" />
        </template>
      </Dialog>
    </section>
    <ConfirmDialog group="deletingComment" :style="{ maxWidth: '490px' }" class="w-11/12 custom-confirm-dialog" />
  </div>
</template>
<script lang="ts">
import { Comment } from "@/models/comment.model";
import { Topic } from "@/models/topic.model";
import { QueryParams } from "@/models/query-params.model";
import { PageState } from "primevue/paginator";
import { defineAsyncComponent, defineComponent, PropType } from "vue";
import { ForumService } from "../../forum.service";
import { take } from "rxjs";
import { ToastFactory } from "@/utils/toast-factory.util";
import { Messages } from "@/utils/messages.util";
import { itemsDenounce } from "@/views/CourseStudent/Forum/utils/denounce.utils";
const CommentCard = defineAsyncComponent(
  () => import("../ListComments/CommentCard/comment-card.vue")
);

export default defineComponent({
  name: "list-comments",
  components: {
    CommentCard,
  },
  props: {
    comments: {
      type: Array as PropType<Comment[]>,
      required: true,
      default: [],
    },
    totalComments: {
      type: Number,
      required: true,
      default: 0,
    },
    numberOfCommentsPerPage: {
      type: Number,
      required: true,
      default: 0,
    },
    topic: {
      type: Object as PropType<Topic>,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      query: new QueryParams(),
      denounceDialogVisible: false,
      descriptionDenounce: "",
      commentId: "",
      denounceComment: itemsDenounce
    }
  },
  methods: {
    onPaginate(event: PageState): void {
      this.query.page = event.page;
      this.$emit("paginate", this.query);
    },
    getFirstItemIndexActualPage(): number | undefined {
      if (this.$route.query.page) {
        return (
          Number(this.$route.query.page) *
          Number(this.numberOfCommentsPerPage) +
          1
        );
      }
    },
    deleteComment(): void {
      this.$emit("deleteComment")
    },
    replyComment(replyComment: Comment): void {
      this.$emit("replyComment", replyComment);
    },
    reportComment(): void {
      if (this.descriptionDenounce != "") {
        this.service.comment.pipe(take(1)).subscribe({
          next: () => {
            this.$toast.add(ToastFactory.success(Messages.FORUM_COMMENT_DENOUNCED));
          }
        })
        this.service.denounceComment(this.topic.id, this.commentId, { description: this.descriptionDenounce });
        this.isDenounceDialogVisible(false);
      }
    },
    commentSelectedId(id: string): void {
      this.commentId = id;
    },
    isDenounceDialogVisible(state: boolean): void {
      this.descriptionDenounce = "";
      this.denounceDialogVisible = state;
    }
  },
  computed: {
    service(): ForumService {
      return new ForumService();
    },
    isDenounceButtonDisabled(): boolean {
      return this.descriptionDenounce === "";
    }
  }
});
</script>
